import { client as apolloClient } from '@xbcb/apollo-client';
import { executeMutation } from './executeMutation';
import { message } from 'antd';
import { ShipmentCommercialInvoiceDetailStatus } from '__generated__/graphql';
import { UPDATE_SHCID } from './handleRejectTask.query';
import { gql } from '@apollo/client';

const GET_SHIPMENT = gql`
  query GetShipment($id: ID!) {
    shipment(id: $id) {
      id
      legs {
        commercialInvoiceDetail {
          id
          version
          status
        }
      }
    }
  }
`;

interface ClearDocumentRejectionParams {
  shipmentId: string;
}

export const clearShipperDocumentsRejection = async ({
  shipmentId,
}: ClearDocumentRejectionParams): Promise<void> => {
  try {
    const { data } = await apolloClient.query({
      query: GET_SHIPMENT,
      variables: { id: shipmentId },
      fetchPolicy: 'network-only',
    });

    const shcid = data?.shipment?.legs?.[0]?.commercialInvoiceDetail;

    if (
      !shcid?.id ||
      shcid.status !== ShipmentCommercialInvoiceDetailStatus.REJECTED
    ) {
      return;
    }

    await executeMutation({
      mutation: UPDATE_SHCID,
      variables: {
        id: shcid.id,
        version: shcid.version,
        input: {
          status: ShipmentCommercialInvoiceDetailStatus.PENDING_REVIEW,
        },
      },
    });
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Unknown error';
    void message.error(`Failed to reset document status: ${errorMessage}`, 5.0);
  }
};
